import { FunctionComponent } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { BuySharedFAQAuthor } from './BuySharedFAQAuthor';

import { BuySharedFAQAnswer_answer } from './__generated__/BuySharedFAQAnswer_answer.graphql';
import styles from './BuySharedFAQAnswer.scss';

type Props = {
    answer: BuySharedFAQAnswer_answer;
};

export const BuySharedFAQAnswerComponent: FunctionComponent<Props> = ({ answer }) => {
    const { serviceId, text, author, formattedCreatedDate } = answer;

    if (text) {
        return (
            <div key={serviceId} className={styles.answer}>
                <BuySharedFAQAuthor author={author} formattedCreatedDate={formattedCreatedDate} />
                <div
                    data-tn="faq-answer-text"
                    dangerouslySetInnerHTML={{
                        __html: text,
                    }}
                />
            </div>
        );
    }
    return null;
};

export const BuySharedFAQAnswer = createFragmentContainer(BuySharedFAQAnswerComponent, {
    answer: graphql`
        fragment BuySharedFAQAnswer_answer on AnswerType {
            serviceId
            text
            formattedCreatedDate
            author {
                ...BuySharedFAQAuthor_author
            }
        }
    `,
});
